import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "offline-part",
  "use": "offline-part-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"offline-part\"><title>部分设备离线</title><path d=\"M6 0a6 6 0 1 0 6 6 6 6 0 0 0-6-6zm-.47 2.71a.47.47 0 1 1 .94 0V7a.47.47 0 1 1-.94 0zM6 9.3a.52.52 0 0 1-.53-.52.53.53 0 0 1 1.06 0A.52.52 0 0 1 6 9.3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/offline-part.svg
// module id = o3eg
// module chunks = 6